import { useAbility } from '@cast/shared-ability-data-access';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useEdgeConfigurationAbilities = () => {
  const { cluster } = useCluster();
  const conditions = { clusterId: cluster?.id };

  const [canView, canCreate, canUpdate, canDelete] = useAbility().canMany(
    [
      ['view', 'ClusterEdgeConfigurations'],
      ['create', 'ClusterEdgeConfigurations'],
      ['update', 'ClusterEdgeConfigurations'],
      ['delete', 'ClusterEdgeConfigurations'],
    ],
    conditions
  );

  return { canView, canCreate, canUpdate, canDelete };
};
